module.exports = __webpack_public_path__ + "static/img/portrait.180a6ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/portrait.jpg
// module id = 34
// module chunks = 0